module.exports = __webpack_public_path__ + "static/media/icon-repair.5b7a6a9b.svg";